import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import logo from "../../images/logo.png"

import "../../css/header.css"

const Header = () => {
    const [resources, setResources] = useState({});
    let navigate = useNavigate();
    const { language } = useParams();

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    return (
        <div className="header-bg mb-4">
            <div className="container wrapper-small header-container">
                <img src={logo} alt="" className="img-fluid logo header-logo-align" />
            </div>
        </div>
    )
}

export default Header